import { george, observer, React, ui, theme, pr } from "aaa";
import { IAccount } from "types/account";
import { amountToCurrencyString, amountToNumber, IAmount, numberToEuroAmount } from "types/amount";
import { isInRange, isNumber, maxDecimal } from "util/formValidations";
import { numberToCurrencyString } from "util/helpers";

const MAX_LIMIT = 10000;
const MAX_LIMIT_GIFT = 50;
const MIN_LIMIT = 10;

const ChooseTopUpComponent = (props: {
    name: string,
    account?: IAccount,
    isLoading?: boolean,
    fees?: IAmount,
    value?: number,
    defaultValue?: number,
    isGift?: boolean,
    max: number;
    disposable: IAmount | null;
    onChange?: (value: string) => void,
}) => (
        <>
            <george.TextFieldFormsy
                name={props.name}
                required
                validations={`isInRange:[10, ${props.max}]`}
                inputValidations={[isNumber, isInRange(0, props.max), maxDecimal(2)]}
                validationError={
                    (value: string) => {
                        const v = Number(value);
                        const minString = numberToCurrencyString(MIN_LIMIT);
                        const maxString = numberToCurrencyString(props.max);

                        if (v > MAX_LIMIT) {
                            // typically not reachable as input is locked.
                            return ui.__("topUpPrepaid.amount.error.max", { value: maxString });
                        } else if (v > props.max && props.max !== MAX_LIMIT) {
                            return ui.__("topUpPrepaid.amount.error.disposable", { value: maxString });
                        } else if (v < MIN_LIMIT) {
                            return ui.__("topUpPrepaid.amount.error.min", { value: minString });
                        }
                    }
                }
                isLoading={props.isLoading}
                centered
                decorator="EUR"
                onChange={(value: string) => {
                    if (props.onChange) { props.onChange(value); }
                }}
                value={props.value}
                defaultValue={props.defaultValue}
                inputMode="decimal"
                aria-label={ui.__("topUpPrepaid.amount")}
            />
            {props.fees &&
                <george.Fees label={ui.__("topUpPrepaid.fee")} value={amountToCurrencyString(props.fees)} />
            }
        </>
    );

export const ChooseTopUpEmbedded = observer((props: {
    name: string,
    account?: IAccount,
    isLoading?: boolean,
    fees?: IAmount,
    value?: number,
    defaultValue?: number,
    isGift?: boolean,
    onChange?: (value: string) => void,
}) => {
    const disposable = props.account && props.account.disposable ? props.account.disposable : null;
    let max = props.isGift ? MAX_LIMIT_GIFT : MAX_LIMIT;
    if (disposable) {
        max = Math.min(max, amountToNumber(disposable));
    }

    return (
        <>
            <george.SectionTitle style={{ marginTop: 0 }}>
                {ui.__("shop.chooseTopUp.title")}
            </george.SectionTitle>
            <george.SectionSubtitleTop>
                {ui.__("shop.chooseTopUp.info", { maxAmount: numberToCurrencyString(max) })}
            </george.SectionSubtitleTop>
            <ChooseTopUpComponent {...props} max={max} disposable={disposable} />
        </>
    );
});

export const ChooseTopUp = observer((props: {
    name: string,
    account?: IAccount,
    isLoading?: boolean,
    fees?: IAmount,
    value?: number,
    defaultValue?: number,
    isGift?: boolean,
    onChange?: (value: string) => void,
}) => {
    const disposable = props.account && props.account.disposable ? props.account.disposable : null;
    let max = props.isGift ? MAX_LIMIT_GIFT : MAX_LIMIT;
    if (disposable) {
        max = Math.min(max, amountToNumber(disposable));
    }

    return (
        <george.Card>
            <george.CardSectionTitle title={ui.__("shop.chooseTopUp.title")} />
            <george.CardSectionContent>
                <george.SectionSubtitleTop>
                    {ui.__("shop.chooseTopUp.info", { maxAmount: numberToCurrencyString(max) })}
                </george.SectionSubtitleTop>
                <ChooseTopUpComponent {...props} max={max} disposable={disposable} />
            </george.CardSectionContent>
        </george.Card>
    );
});

export const ChooseTopUpResponsive = observer((props: {
    name: string,
    account?: IAccount,
    isLoading?: boolean,
    fees?: IAmount,
    value?: number,
    defaultValue?: number,
    isGift?: boolean,
    onChange?: (value: string) => void,
}) => {
    const disposable = props.account && props.account.disposable ? props.account.disposable : null;
    let max = props.isGift ? MAX_LIMIT_GIFT : MAX_LIMIT;
    if (disposable) {
        max = Math.min(max, amountToNumber(disposable));
    }

    return (
        <>
            <george.SectionTitle style={{ marginTop: 0 }}>
                {ui.__("shop.chooseTopUp.title")}
            </george.SectionTitle>
            <pr.P_14_CONTENT style={{ marginBottom: theme.MARGIN }}>
                {ui.__("shop.chooseTopUp.info", { maxAmount: numberToCurrencyString(max) })}
            </pr.P_14_CONTENT>
            <george.ResponsiveFormElement label={ui.__("common.amount")}>
                <ChooseTopUpComponent {...props} max={max} disposable={disposable} />
            </george.ResponsiveFormElement>
        </>
    );
});


// WEBPACK FOOTER //
// ./src/components/common/ChooseTopUp.tsx